import { render, staticRenderFns } from "./KoPaymentDetailsEdit.vue?vue&type=template&id=2ce90224&"
import script from "./KoPaymentDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./KoPaymentDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports